export const startPageNewsUK = state => state.startPageNews.startPageNewsUK;
export const startPageNewsRU = state => state.startPageNews.startPageNewsRU;
export const startPageNewsErrorUK = state =>
  state.startPageNews.startPageNewsErrorUK;
export const startPageNewsErrorRU = state =>
  state.startPageNews.startPageNewsErrorRU;
export const startPageNewsLoading = state => state.startPageNews.loading;
